/**
 * Available fonts for the menu builder
 * Includes Google Fonts and web-safe fonts
 */

export interface FontOption {
  label: string;
  value: string;
  type: 'google' | 'system';
  category: 'sans-serif' | 'serif' | 'display' | 'handwriting' | 'monospace';
}

export const AVAILABLE_FONTS: FontOption[] = [
  // System Fonts
  { label: 'System Default', value: 'inherit', type: 'system', category: 'sans-serif' },
  { label: 'Genty Sans', value: 'Genty Sans', type: 'system', category: 'sans-serif' },
  { label: 'Sans Serif', value: 'sans-serif', type: 'system', category: 'sans-serif' },
  { label: 'Serif', value: 'serif', type: 'system', category: 'serif' },
  { label: 'Monospace', value: 'monospace', type: 'system', category: 'monospace' },
  
  // Google Fonts - Sans Serif
  { label: 'Inter', value: 'Inter', type: 'google', category: 'sans-serif' },
  { label: 'Roboto', value: 'Roboto', type: 'google', category: 'sans-serif' },
  { label: 'Open Sans', value: 'Open Sans', type: 'google', category: 'sans-serif' },
  { label: 'Lato', value: 'Lato', type: 'google', category: 'sans-serif' },
  { label: 'Poppins', value: 'Poppins', type: 'google', category: 'sans-serif' },
  { label: 'Montserrat', value: 'Montserrat', type: 'google', category: 'sans-serif' },
  { label: 'Bricolage Grotesque', value: 'Bricolage Grotesque', type: 'google', category: 'sans-serif' },
  
  // Google Fonts - Serif
  { label: 'Playfair Display', value: 'Playfair Display', type: 'google', category: 'serif' },
  { label: 'Merriweather', value: 'Merriweather', type: 'google', category: 'serif' },
  { label: 'Lora', value: 'Lora', type: 'google', category: 'serif' },
  { label: 'Crimson Text', value: 'Crimson Text', type: 'google', category: 'serif' },
  
  // Google Fonts - Display/Handwriting
  { label: 'Dancing Script', value: 'Dancing Script', type: 'google', category: 'handwriting' },
  { label: 'Pacifico', value: 'Pacifico', type: 'google', category: 'handwriting' },
  { label: 'Lobster', value: 'Lobster', type: 'google', category: 'display' },
  { label: 'Comfortaa', value: 'Comfortaa', type: 'google', category: 'display' },
  { label: 'Righteous', value: 'Righteous', type: 'google', category: 'display' },
  
  // Arabic Fonts (Google Fonts)
  { label: 'Cairo', value: 'Cairo', type: 'google', category: 'sans-serif' },
  { label: 'Tajawal', value: 'Tajawal', type: 'google', category: 'sans-serif' },
  { label: 'Almarai', value: 'Almarai', type: 'google', category: 'sans-serif' },
  { label: 'Amiri', value: 'Amiri', type: 'google', category: 'serif' },
  { label: 'Lateef', value: 'Lateef', type: 'google', category: 'handwriting' },
];

/**
 * Helper to generate Google Fonts URL
 */
export const getGoogleFontsUrl = (fonts: string[]) => {
  if (!fonts.length) return '';
  
  const fontParams = fonts
    .map(font => `${font.replace(/ /g, '+')}:wght@300;400;500;600;700`)
    .join('&family=');
    
  return `https://fonts.googleapis.com/css2?family=${fontParams}&display=swap`;
};
